<template>
  <div><slot></slot></div>
</template>

<script>
  export default {
    name: "base-portal-left-sidebar"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-portal-left-sidebar.vue